import {styled as st} from "@mui/material/styles";
import {pink} from "@mui/material/colors";
import {alpha, FormControlLabel} from "@mui/material";
import {useContext, useEffect, useState} from "react";
import Switch from "@mui/material/Switch";
import TechnicalEngagementContext from "./TechnicalEngagementContext";
import EnvironmentContext from "./EnvironmentContext";




const GreenSwitch = st(Switch)(({theme}) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: pink[600],
        '&:hover': {
            backgroundColor: alpha(pink[600], theme.palette.action.hoverOpacity),
        },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: pink[600],
    },
}));
const Switcher = (props) => {
    const {switchLabel, setSwitchLabel} = props;
    const [checked, setChecked] = useState(false)
    const {technicalEngagement} = useContext(TechnicalEngagementContext);
    const {environment,setEnvironment} = useContext(EnvironmentContext);


    const handleSwitch = () => {
        if (switchLabel === "No") {
            setChecked(true)
            setSwitchLabel("Yes");
        } else  {
            setSwitchLabel("No");
            setChecked(false)
            setEnvironment(prevState => {
                return {
                    ...prevState,
                    customer_email: "",
                    is_invitation: false
                }
            })
        }
    }

    useEffect(() => {
        setSwitchLabel("No");
        setChecked(false);
        }
        , [technicalEngagement.opportunity, technicalEngagement.accountName, setSwitchLabel]);

    useEffect(() => {
            if(environment.region !== "" && environment.is_invitation === true){
                setSwitchLabel("Yes");
                setChecked(true);
            }
        }
        , [environment.region, environment.is_invitation, setSwitchLabel]);

    return (
        <>
            <FormControlLabel control={<GreenSwitch/>} id={"switcher"} checked={checked} onChange={handleSwitch} label={<p style={{"fontSize":"14px"}}>{switchLabel}</p>}/>
            {switchLabel === "Yes" && props.children}
        </>
    )
}

export default Switcher;
